export interface StatusStyles {
  statusColor: string;
  statusTextColor: string;
  border: string;
}

export const getStatusStyles = (status: string): StatusStyles => {
  const statusMap: Record<string, StatusStyles> = {
    Arrived: {
      statusColor: "#E8F5E9",
      statusTextColor: "#4CAF50",
      border: "1px solid #4BA663",
    },
    "In Transit": {
      statusColor: "#E3F2FD",
      statusTextColor: "#2196F3",
      border: "1px solid #1E90FF",
    },
    "In-Transit": {
      statusColor: "#E3F2FD",
      statusTextColor: "#2196F3",
      border: "1px solid #1E90FF",
    },
  };

  return statusMap[status] || statusMap["In Transit"];
};
